import React, { useState } from "react";
import { Modal, Button, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { confirmCashout } from "../../../network";
import { toastError, toastSuccess } from "../../../helpers/toasters";

function CashoutConfirmation({ open, setOpen, data }) {
  const { t } = useTranslation();
  const [isReceivedLoading, setIsReceivedLoading] = useState(false);
  const [isNotReceivedLoading, setIsNotReceivedLoading] = useState(false);

  const openWhatsApp = (phoneNumber, message) => {
    const cleanedNumber = phoneNumber.replace(/\D/g, "");
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${cleanedNumber}?text=${encodedMessage}`;

    // window.open(whatsappUrl, "_blank");
    window.location.href = whatsappUrl;

  };

  const onConfirm = (IsAccepted) => {
    const requestData = {
      IsAccepted,
    };

    if (IsAccepted) {
      setIsReceivedLoading(true);
    } else {
      setIsNotReceivedLoading(true);
    }

    confirmCashout(
      requestData,
      (res) => {
        toastSuccess(res?.message || "Cashout confirmed successfully!");
        setOpen(false);
        setIsReceivedLoading(false);
        setIsNotReceivedLoading(false);

        if (IsAccepted) {
          const receivedMessage =
            data?.whatsAppApproveMessage || "I received my cash out";
          openWhatsApp(data?.wahtsAppNumber, receivedMessage);
        } else {
          const notReceivedMessage =
            data?.whatsDisAppApproveMessage ||
            "I haven't received my cash out yet";
          openWhatsApp(data?.wahtsAppNumber, notReceivedMessage);
        }
      },
      (err) => {
        toastError(err?.message || "An error occurred!");
        setIsReceivedLoading(false);
        setIsNotReceivedLoading(false);
      },
    );
  };

  return (
    <Modal
      open={open}
      centered
      footer={null}
      maskClosable={false}
      closable={false}
      width={
        window.innerWidth >= 1440
          ? "60%"
          : window.innerWidth >= 768
            ? "70%"
            : "100%"
      }
    >
      <div className="d-flex flex-column cashout-confirmation__container">
        <Typography.Title
          level={window.innerWidth >= 768 ? 2 : 3}
          className="text-center cashout-confirmation__title"
        >
          {t("cashoutConfirmation.title")}
        </Typography.Title>

        <div className="cashout-confirmation__messages-container">
          <p className="cashout-confirmation__description">
            {data?.approveMessage}
          </p>

          <p className="cashout-confirmation__description">
            {data?.disApproveMessage}:{" "}
            <span className="cashout-confirmation__description-number">
              {data?.wahtsAppNumber}
            </span>
          </p>
        </div>

        <div className="cashout-confirmation__buttons-container">
          <Button
            onClick={() => onConfirm(false)}
            loading={isNotReceivedLoading}
            disabled={isNotReceivedLoading}
            className="cashout-confirmation__button cashout-confirmation__button--cancel"
          >
            {t("cashoutConfirmation.notRecieved")}
          </Button>

          <Button
            onClick={() => onConfirm(true)}
            loading={isReceivedLoading}
            disabled={isReceivedLoading}
            className="cashout-confirmation__button cashout-confirmation__button--confirm border-0"
          >
            {t("cashoutConfirmation.recieved")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default CashoutConfirmation;
